import { Component } from '@angular/core';

@Component({
  selector: 'app-hdc-info-modal',
  templateUrl: './hdc-info-modal.component.html',
  styleUrls: ['./hdc-info-modal.component.scss'],
})
export class HdcInfoModalComponent {}
